import { createFileRoute, notFound } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { apiClient } from "@/lib/api/client";
import { APP_ID } from "@/routes/_staff/app-integrations/$id/_$id/-constant";

const SearchSchema = z.object({
  installDialogDefaultOpen: z.boolean().optional(),
});

export const Route = createFileRoute("/_staff/apps/_list/marketplace/$id")({
  validateSearch: zodValidator(SearchSchema),
  loader: async ({ params }) => {
    if (params.id === APP_ID.CUSTOM_APP) {
      throw notFound();
    }
    const res = await apiClient.GET("/v2/apps/{id}", {
      params: { path: { id: params.id } },
    });
    if (!res.data) throw notFound();

    return res.data;
  },
});
